import { darken, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  title: {
    fontSize: '1.5rem',
  },
  subtitle: {
    marginBottom: '15px',
  },
  label: {
    color: '#000000',
    marginBottom: '5px',
  },
  inputRow: {
    alignItems: 'flex-end',
    marginBottom: '15px',
  },
  operationMode: {
    marginBottom: '15px',
  },
  clearFiltersButton: {
    border: 'none',
    backgroundColor: 'transparent',
    padding: '10px 20px',
    fontSize: '0.9rem',
    color: '#0d47a1',
    letterSpacing: '0.03em',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    '&:hover': {
      color: darken('#0d47a1', 0.2),
    },
    '&:disabled': {
      backgroundColor: '#DDD',
    },
  },
  consultButton: {
    color: '#ffffff',
    backgroundColor: '#0d47a1',
    '&:hover': {
      backgroundColor: darken('#0d47a1', 0.2),
    },
    '&:disabled': {
      backgroundColor: '#DDD',
    },
    padding: '10px 20px',
    textTransform: 'capitalize',
    fontSize: '0.9rem',
    letterSpacing: '0.04em',
  },
}));
